import { createStyles, Theme } from '@material-ui/core/styles';

const mapStyles = ({
  spacing, flags, colors, typography,
}: Theme) => createStyles({
  root: {
    height: spacing(80),
  },
  searchField: {
    border: 'none',
    paddingBottom: spacing(2),
    '&:focus-visible': {
      outline: 'none',
    },
    '& .leaflet-control-search': {
      display: 'flex',
      '&:focus-visible': {
        outline: 'none',
      },
      '&.search-exp': {
        border: 'none',
        background: 'none',
      },
      '&.search-load': {
        '& input.search-input': {
          background: 'none',
        },
      },
    },

    '& input.search-input': {
      ...typography.textRegular,
      padding: spacing(2),
      paddingRight: spacing(10),
      outline: flags.boxStyle === 'stroke' ? 'none' : `1px solid ${colors.inputs.inputField.enabled.stroke}`,
      borderRadius: colors.inputs.inputField.corner,
      borderBottom: flags.boxStyle === 'stroke' ? `2px solid ${colors.textMainPrimary}` : 'none',
      border: 'none',
      flexGrow: 1,
      float: 'none',
      font: 'inherit',
      color: colors.inputs.inputField.textRegular,
      margin: 0,
      display: 'block',
      minWidth: 0,
      background: 'none',
      boxSizing: 'content-box',
      maxWidth: '100% !important',
    },

    '& .search-tip': {
      whiteSpace: 'normal',
    },
    '& .search-tooltip': {
      width: '100%',
    },

    '& .search-button': {
      position: 'absolute',
      right: 0,
      top: spacing(1),
    },
    '& .search-cancel': {
      position: 'absolute',
      top: spacing(1),
    },
  },
  customRadius: {
    paddingBottom: spacing(2),
  },
});

export default mapStyles;
